import * as _ from 'lodash';
import { EmailTemplate } from './email-templates/emailTemplate';
import { MandrillEmailTemplateType } from './email-templates/mandrill-email-template-type';

export enum EmailScenario {
  Confirmation = 'Confirmation',
  Default = 'Default',
  TeamEmail = 'TeamEmail',
  Reminder = 'Reminder',
  Declined = 'Declined',
  GeneralEmail = 'GeneralEmail',
}
export class EmailCustomization {
  public id: string;
  public scenario: EmailScenario;
  public subject: string;
  public content: string;
  public contactName: string;
  public contactEmail: string;
  public mandrillTemplateName: MandrillEmailTemplateType; // Mandrill template name
  public buttonText: string; // used in preview to render button
  public buttonLink: string; // used in preview to render button link
  public replyTo: string;

  public emailTemplate: EmailTemplate;

  private isCustomOverride: boolean;

  constructor(
    id: string,
    scenario: EmailScenario,
    subject: string,
    content: string,
    contactName: string,
    contactEmail: string,
    emailTemplate: EmailTemplate = null,
    mandrillTemplateName: MandrillEmailTemplateType = null,
    buttonText: string = null,
    buttonLink: string = null,
    replyTo: string = null
  ) {
    this.id = id;
    this.scenario = scenario;
    this.subject = subject;
    this.content = content;
    this.contactName = contactName;
    this.contactEmail = contactEmail;
    this.emailTemplate = emailTemplate;
    this.mandrillTemplateName = mandrillTemplateName;
    this.buttonText = buttonText;
    this.buttonLink = buttonLink;
    this.replyTo = replyTo;
  }

  get isCustom(): boolean {
    return this.isCustomOverride || !!this.id;
  }

  // force isCustom to return true even when there's no ID, i.e., after saving a new
  // email customization and displaying it before reloading it from the server
  overrideIsCustom(override: boolean): void {
    this.isCustomOverride = override;
  }

  isDefaultScenario(): boolean {
    return this.scenario == EmailScenario.Default;
  }

  isConfirmationScenario(): boolean {
    return this.scenario == EmailScenario.Confirmation;
  }

  static empty(scenario: EmailScenario): EmailCustomization {
    return new EmailCustomization(
      null,
      scenario,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null
    );
  }

  static build(
    subject: string,
    content: string,
    contactName: string,
    contactEmail: string,
    mandrillTemplateName: MandrillEmailTemplateType = null,
    buttonText: string = null,
    buttonLink: string = null,
    replyTo: string = null
  ) {
    return new EmailCustomization(
      null,
      EmailScenario.Default,
      subject,
      content,
      contactName,
      contactEmail,
      null,
      mandrillTemplateName,
      buttonText,
      buttonLink,
      replyTo
    );
  }

  static parseMany(arr: any[]): Array<EmailCustomization> {
    if (!arr) return [];
    return _.map(arr, (obj) => EmailCustomization.parse(obj));
  }

  static parse(obj: any): EmailCustomization {
    if (!obj) return;

    return new EmailCustomization(
      obj.id,
      obj.scenario,
      obj.subject,
      obj.content,
      obj.contactName,
      obj.contactEmail,
      EmailTemplate.parse(obj.emailTemplate),
      obj.mandrillTemplateName,
      obj.buttonText,
      obj.buttonLink,
      obj.replyTo
    );
  }
}
